module.exports = __webpack_public_path__ + "img/wyh.bcd0fd91.png";